/**
 * Shared TanStack QueryClient for the pratica-status feature — F-005 Phase 4.
 *
 * Mirrors `features/archivio/lib/query-client.ts`: a feature-scoped QueryClient
 * (the app has no global one) mounted by the F-005 pages via
 * `QueryClientProvider` in Phase 5/6. A single client across the list and the
 * detail routes lets the polling caches share state.
 *
 * Defaults chosen for the stato-pratica UX:
 *  - `staleTime: 30_000` — list/detail stay fresh for 30s (matches the polling
 *    cadence) so navigating away and back doesn't trigger an extra refetch.
 *  - `retry: 1` — one retry on transient network errors before surfacing.
 *  - `refetchOnWindowFocus: false` — the page already polls every 30s; focus
 *    refetches would double the traffic and flicker the list.
 */
import { QueryClient } from '@tanstack/react-query';

export function createPraticaStatusQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 1,
      },
    },
  });
}

/**
 * Module-level singleton — sufficient for the feature: the QueryClient lives for
 * the SPA session and a single client across the list / detail / correction
 * routes lets cached entries pre-populate one another.
 */
export const praticaStatusQueryClient = createPraticaStatusQueryClient();
